var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"sticky bar"},[_vm._t("inner")],2)}
var staticRenderFns = []

export { render, staticRenderFns }